import { ReplaceAllRequest } from './ReplaceAllRequest'

export function replaceAll (request: ReplaceAllRequest): string {
  return request.input.split(request.replace).join(request.value)
}
